import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { Tooltip, Typography } from '@mui/material';
import React, { type JSX } from 'react';

type GroupPathProps = {
    pathName: any[];
    width?: string;
    deviceName?: string;
    tooltip?: boolean;
    fontWeight?: any;
    separator?: any;
    color?: string;
    opacity?: number;
    isFirstBold?: boolean;
};

const getSeparatorHandler = (index: number, pathName: any, separator: any, isFirstBold: boolean): any => {
    if (index !== pathName.length - 1) {
        if (!separator) {
            return (
                <ChevronLeft
                    fontSize="small"
                    sx={{ position: 'relative', top: '5px', color: isFirstBold ? '#727E84' : 'inherit' }}
                />
            );
        }
        return ` ${separator}`;
    }
    return '';
};

export const GroupPath = ({
    pathName,
    width = '90%',
    deviceName,
    tooltip,
    fontWeight = 300,
    separator,
    color,
    opacity,
    isFirstBold = false,
}: GroupPathProps): JSX.Element => {
    if (!Array.isArray(pathName)) {
        return <></>;
    }

    const safePath = pathName;
    const deviceLabel = deviceName ?? '';
    const title = `${deviceLabel ? `${deviceLabel}/` : ''}${safePath.join('/')}`;
    const showDeviceSeparator = Boolean(deviceLabel) && safePath.length > 0;
    const newPath = [...safePath].reverse();

    return (
        <Tooltip title={title} disableHoverListener={!tooltip} arrow>
            <Typography
                variant={'body2'}
                sx={{
                    textOverflow: 'ellipsis',
                    width,
                    fontWeight,
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    color,
                    opacity,
                }}
            >
                {deviceLabel && <span style={{ fontWeight: 400 }}>{deviceLabel}</span>}
                {showDeviceSeparator && <ChevronLeft fontSize="small" sx={{ position: 'relative', top: '5px' }} />}
                {newPath.map((groupName: string, index: number): JSX.Element => {
                    const groupPathKey = `${newPath.slice(0, index + 1).join('/')}-${groupName}-${index}`;

                    return (
                        <span key={groupPathKey}>
                            <span style={{ fontWeight: isFirstBold && index === 0 ? 600 : fontWeight }}>
                                {groupName}
                            </span>
                            {getSeparatorHandler(index, safePath, separator, isFirstBold && index === 0)}
                        </span>
                    );
                })}
            </Typography>
        </Tooltip>
    );
};
